export enum Role {
    ADMIN = "ADMIN",
    MANAGER = "MANAGER",
    STANDARD = "STANDARD"
}